import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { Backdrop as i } from "../Backdrop/Backdrop.js";
import { attributes as m } from "../utils/attributes.js";
import { classnames as c } from "../utils/classnames.js";
import '../../assets/Sheets.css';function f({ open: s, onClose: t, children: r }) {
  const a = m({ "aria-expanded": s });
  return /* @__PURE__ */ o(
    "div",
    {
      className: c(
        ["sheets-container"],
        ["sheets-container--open", s]
      ),
      children: [
        /* @__PURE__ */ e(i, { onClose: t, open: s, className: "sheets-backdrop" }),
        /* @__PURE__ */ e("div", { className: "sheets", ...a, children: r })
      ]
    }
  );
}
export {
  f as Sheets
};
//# sourceMappingURL=Sheets.js.map
